import PointerMapDark from '../../src/assets/map/mapPionterDark.png';

export const questionsAmount = (test) => {
  if (test?.difficultyConfig?.length > 0) {
    return test?.difficultyConfig?.reduce(
      (accumulator, currentValue) => accumulator + currentValue?.quantity,
      0
    );
  }
  return test?.testsQuantityToEvaluate
    ? test?.testsQuantityToEvaluate
    : test?.tests?.length
    ? test?.tests?.length
    : test?.testsQuantity;
};

/**
 * Transform an array of location objects into a standardized options object used elsewhere in the application.
 * @param locations An array of location objects, each containing properties like id, label, position, and radiusInKm.
 * @returns – An object with an options property that is an array of mapped location objects,
 * where each object includes:
 * • id
 * • text (derived from label or formatedAddres)
 * • formula (a string combining latitude and longitude)
 * • weight (using radiusInKm)
 * • correct (set to true)
 */

export const mapLocationToOptions = (locations) => ({
  options: locations.map((place) => ({
    id: place.id,
    text: place.label || place.formatedAddres,
    formula: `${place?.position?.lat},${place?.position?.lng}`,
    weight: place.radiusInKm,
    correct: true,
  })),
});

/**
 *  Convert an array of option objects (and optionally acceptedOptions) into an array of location objects formatted for use in the application.
 *
 * @param  options: An array of options that may contain a formula property (as a comma-separated string with latitude and longitude) and a weight property for the radius.
 * @param  acceptedOptions (optional): An array of objects that can override the formula details if provided
 * @returns  An array of location objects. Each object includes:
 * • id
 * • label (same as the option’s text)
 * • formatedAddres (same as the text)
 * • position: with lat and lng (extracted from formula or acceptedOptions)
 * • radiusInKm (using the weight property
 */
export const mapOptionsToLocations = (options, acceptedOptions) =>
  options.map((option, index) => {
    let [lat, lng] = [0, 0];
    let radius = 1;
    if (option.formula) {
      [lat, lng] = option?.formula?.split(',')?.map(Number);
      radius = option.weight;
    }
    if (acceptedOptions) {
      [lat, lng] = acceptedOptions[index]?.options?.[0]?.split(',')?.map(Number);
      radius = acceptedOptions[index].weight;
    }

    return {
      id: option.id,
      label: option.text,
      formatedAddres: option.text,
      position: {
        lat,
        lng,
      },
      radiusInKm: radius,
    };
  });

/**
 * Map a submission object into a formatted location object that can be used directly in the application.
 *
 * @param {submissionDto} submission An object containing submitted data with properties like submittedOptions (for coordinates as strings) and submittedText.
 * @returns A location object containing:
 *  • id (from testId)
 *  • label (from submittedText)
 *  • formattedAddress (also from submittedText)
 *  • color (a fixed value, e.g., '#67e0aeff')
 *  • radiusInKm (a fixed small value, 0.005)
 *  • position: with lat and lng (extracted by mapping submittedOptions to numbers
 */
export const mapSubmissionToLocation = (submission) => {
  const [lat, lng] = submission?.submittedOptions?.map(Number);

  return {
    id: submission?.testId,
    label: submission?.submittedText,
    formattedAddress: submission?.submittedText,
    color: '#67e0aeff',
    radiusInKm: 0.01,
    className: 'map-marker-label',
    icon: PointerMapDark,
    position: {
      lat,
      lng,
    },
  };
};
